import Breadcrumb from '../../component/breadcrumb/breadcrumb';
import TabBar from '../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import SelectLecturerPage from './salaries/select-lecturer.page';
import { PaymentPageTabs } from './tabs/payment-page-tabs';

const tabs = ['שרותי תשלום'];

const PaymentsPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const pages = [<PaymentPageTabs />];

  return (
    <div>
      {/*<Breadcrumb
        onClick={(index) => {
          // TODO
        }}
        crumbs={['הגדרות מערכת', 'שרותים']}
      ></Breadcrumb>*/}
      <div
        style={{
          color: '#041E49',
          fontSize: '30px',
          fontWeight: 'bold',
          marginTop: '20px',
          marginBottom: '16px',
        }}
      >
        תשלומים
      </div>

      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>

      <br />

      {pages[selectedIndex]}
    </div>
  );
};

export default PaymentsPage;
